import React, { useCallback } from 'react'
import styled from 'styled-components'
import AlchemyModal, { ModalBody, ModalHeader, ModalProps } from 'UIKit/AlchemyModal'
import ProviderFilterContainer, { ProviderFilterContainerProps } from './ProviderFilterContainer'

export interface ProviderFilterModalProps extends ProviderFilterContainerProps {
  onDismiss?: () => void
}

const ProviderFilterModal: React.FC<ModalProps<ProviderFilterModalProps>> = ({ onDismiss, data }) => {
  const handleSubmit = useCallback(() => {
    data?.submitCallback?.()
    onDismiss?.()
  }, [data?.submitCallback, onDismiss])

  return (
    <AlchemyModal onDismiss={onDismiss} colorTheme="darkblue">
      <ModalHeader colorTheme="darkblue" title="Choose Providers" />

      <ModalBody>
        <StyledProviderFilterContainer
          selectedProviders={data?.selectedProviders || []}
          onProvidersChanged={data?.onProvidersChanged}
          submitCallback={handleSubmit}
        />
      </ModalBody>
    </AlchemyModal>
  )
}

const StyledProviderFilterContainer = styled(ProviderFilterContainer)`
  background: transparent;
  width: 100%;
  box-shadow: none;
  border: 0px;
`

export default ProviderFilterModal
